import React, { useEffect, useRef } from 'react';
import { Box, Input, useTheme } from '@mui/material';
import { FaOptionIcon } from '@europrocurement/l2d-icons';
import { faSearch } from '@fortawesome/sharp-regular-svg-icons';

export type FlexyFilterSearchInputProps = {
    placeholder: string;
    searchTerm: string;
    onSearchTermUpdate: (searchTerm: string) => void;
};

export const FlexyFilterSearchInput: React.FunctionComponent<FlexyFilterSearchInputProps> =
    function (props) {
        const { placeholder, searchTerm, onSearchTermUpdate } = props;
        const theme = useTheme();
        const searchInputRef = useRef<HTMLInputElement>(null);

        useEffect(() => {
            searchInputRef?.current?.focus();
        }, [searchInputRef]);

        return (
            <Box
                sx={{
                    borderColor: theme.palette.grey[400],
                    borderWidth: '1px',
                    borderStyle: 'solid',
                    display: 'flex',
                    borderRadius: '12px',
                    alignItems: 'center',
                    padding: '0 10px',
                }}
            >
                <FaOptionIcon
                    color={theme.palette.text.primary}
                    icon={faSearch}
                />
                <Input
                    placeholder={placeholder}
                    onChange={(e) => onSearchTermUpdate(e.target.value)}
                    value={searchTerm}
                    fullWidth
                    disableUnderline
                    inputProps={{
                        ref: searchInputRef,
                        sx: {
                            color: theme.palette.text.primary,
                            height: '48px',
                            boxSizing: 'border-box',
                            padding: '8px 16px;',
                            fontSize: '16px',
                            fontWeight: '400',
                            lineHeight: '32px',
                            textAlign: 'left',
                        },
                    }}
                />
            </Box>
        );
    };
